import { useSearch } from "@tanstack/react-router";

import {
  PROFILING_IFRAME_BASE_URL,
  PROFILING_IFRAME_PARAM_KEY,
} from "@/domains/profile/models/constants";
import { buildUtmQueryParams } from "@/utils/utm";

const PROFILING_ROUTE_ID = "/_guest/profiling/";

export const useProfilingQueryParams = (personifyQueryParams: [string, string][] | undefined) => {
  const { utm_medium } = useSearch({ from: PROFILING_ROUTE_ID });

  return [
    ...(personifyQueryParams ?? []),
    [PROFILING_IFRAME_PARAM_KEY, PROFILING_IFRAME_BASE_URL],
    ...buildUtmQueryParams(utm_medium),
  ] satisfies [string, string][];
};
